
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.161 12.535a.57.57 0 01-.405-.168L.511 8.123a.572.572 0 11.81-.81l3.84 3.838 8.518-8.519a.572.572 0 11.81.81l-8.922 8.925a.571.571 0 01-.406.168z"}})])
          )
        }
      }
    